<template>
  <div>
    <div class="multiselect-wrapper mb-5">
      <span class="multiselect-label" style="width: 180px;text-align-last: center;">{{getLocalization('Services')}}</span>
      <multiselect
          v-model="selectedService"
          :placeholder="getLocalization('Select service')"
          @select="selectService"
          label="title"
          track-by="id"
          :closeOnSelect="true"
          :group-select="true"
          :showLabels="false"
          :options="servicesLabels"
          :option-height="40"
          :multiple="false"
      >
        <template slot="option" slot-scope="props">
          <img :src="props.option.img_path">
          <span>{{ props.option.title }}</span>
        </template>
      </multiselect>
    </div>


    <div class="multiselect-wrapper mb-5 mt-5">
      <span class="multiselect-label" style="width: 180px;text-align-last: center;">{{getLocalization('Domain')}}</span>
      <multiselect
          v-model="selectedDomain"
          :placeholder="getLocalization('Select domain')"
          @select="selectDomain"
          label="front_name"
          track-by="id"
          :closeOnSelect="true"
          :group-select="true"
          :showLabels="false"
          :options="domainsLabels"
          :option-height="40"
          :multiple="false"
      >
        <template slot="option" slot-scope="props">
          <img :src="props.option.img_path">
          <span>{{ props.option.front_name }}</span>
        </template>
      </multiselect>
    </div>

    <div class="multiselect-wrapper mb-5">
      <span class="multiselect-label" style="width: 180px;text-align-last: center;">{{getLocalization('Count')}}</span>
      <input type="text" class="multiselect__tags"
             style="width: 100%; font-size: 18px; font-weight: 600;color: #2c7057;"
             :placeholder="getLocalization('Enter the quantity')"
             @input="updateTotalAmount"
             :value="countToBuy">
    </div>

    <div class="multiselect-wrapper mb-5">
      <span class="multiselect-label" style="width: 180px;text-align-last: center;">{{getLocalization('Time')}}</span>
      <input type="text" class="multiselect__tags" style="width: 100%;font-size: 18px; font-weight: 600;color: #2c7057;" :placeholder="timeForOrder" readonly v-model="timeForOrder">
    </div>

    <div class="multiselect-wrapper mb-5">
      <span class="multiselect-label" style="width: 180px;text-align-last: center;">{{getLocalization('Count of sms')}}</span>
      <input type="text" class="multiselect__tags" style="width: 100%;font-size: 18px; font-weight: 600;color: #2c7057;" :placeholder="getLocalization('Enter number of sms')" readonly v-model="countOfSms">
    </div>
    <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 15px; font-size: 25px">
      <b>{{getLocalization('Total')}}: {{totalAmount}} ₽</b>
    </div>
    <div style="width: 100%; padding-top: 10px; display: flex; justify-content: flex-end;">
      <button class="button orange primary" @click="buyBatchMail">{{ getLocalization('Buy now') }}</button>
    </div>
    <div style="border-top: 2px solid black;width: 100%; padding-top: 10px; display: flex; justify-content: center; margin-top: 20px;">
      <batch-mail-history></batch-mail-history>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import WrapperFiltersComponent from "../../../components/table/wrapperFilters.vue";
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import BarChart from "../../../components/LineChart/barChart.vue";
import GraphDynamic from "../../../components/mixins/GraphDynamicMixin";
import Modal from "../../../components/table/modalNew.vue";
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin.vue";

export default {
  name: "buyBatchMail",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    GraphDynamic,
    BaseAdminMixin,
  ],
  components: {
    Modal,
    BarChart,
    BaseTable,
    Multiselect,
    WrapperFiltersComponent
  },
  data: function () {
    return {
      selectedService: {
        activate_org_code: "tg",
        id: 5,
        title: "Telegram"
      },
      selectedDomain: [],
      servicesLabels: [],
      domainsLabels: [],
      countOfSms: 1,
      countToBuy: null,
      timeForOrder: '24 hours',
      selectedServiceId: 5,
      selectedServiceOrg: 'tg',
      priceForSelectedVariation: 0,
      selectedDomainId: '',
      totalAmount: 0,
      allMailPrices: 0,
      allData: null
    }
  },
  async mounted() {
    await this.setUpBatchMailForm();
  },
  methods: {
    async selectService(option) {
      this.selectedServiceId = option.id;
      this.selectedServiceOrg = option.activate_org_code;
      let pricesByService = await this.sendRequest('/activations/getMailRestsByService', 'get', {serviceId: this.selectedServiceId});
      let restsDomains = pricesByService['mails'][this.selectedServiceId];
      restsDomains = [].concat(restsDomains);
      let domainsList = []
      restsDomains.forEach(service => {
            if (Array.isArray(service.rests)) {
              service.rests.forEach(rest => {
                if (!domainsList.some(item => item.id === rest.id)) {
                  domainsList.push(rest['domain']);
                }
              });
            }
          });
      this.domainsLabels = domainsList
      this.allData = pricesByService
      if(this.selectedDomainId !== ''){
        let variation = [].concat(this.allData['mails'][this.selectedServiceId]['rests']);
        variation.forEach(service => {
          if(service.service.id == this.selectedServiceId && service.domain.name == this.selectedDomainId){
            this.priceForSelectedVariation = service.price
          }
        })
      }
      this.updateTotalAmount(null);
      this.resetData();
    },
    resetData() {
      this.selectedDomain = [];
      this.selectedDomainId = '';
      this.totalAmount = 0;
      this.countOfSms = 1;
      this.countToBuy = null;
    },
    selectDomain(option) {
      this.selectedDomainId = option.name;
      let variation = [].concat(this.allData['mails'][this.selectedServiceId]['rests']);
      variation.forEach(service => {
        if(service.service.id == this.selectedServiceId && service.domain.name == this.selectedDomainId){
          this.priceForSelectedVariation = service.price
        }
      })
      this.updateTotalAmount(null);
    },
    async setUpBatchMailForm() {
      this.allData = await this.sendRequest('/activations/getMailRestsByService', 'get', {
        serviceId: this.selectedService.id,
        withPopular: true,
      })
      // Собираем все доступные сервисы с пульта
      this.servicesLabels = Object.values(this.allData['mails']);
      // Собираем все доступные домены для этого сервиса
      let domainsList = [];
      this.servicesLabels.forEach(service => {
        if (Array.isArray(service.rests)) {
          service.rests.forEach(rest => {
            if (!domainsList.some(item => item.id === rest.id)) {
              domainsList.push(rest['domain']);
            }
          });
        }
      });
      this.domainsLabels = domainsList
    },
    async buyBatchMail() {
      let domainIdToBuy = this.selectedDomainId;
      let serviceIdToBuy = this.selectedServiceOrg;
      let countToBuy = this.countToBuy;
      let data = {
        service: serviceIdToBuy,
        domain: domainIdToBuy,
        count: countToBuy,
      }
      let response = await this.sendRequest('/web/mail/getBatch', 'get', data);
      if(response?.status == 1){
        await this.alertMessage(this.getLocalization('Purchase is successful'),'info');
        setTimeout(function() {
          location.reload();
        }, 2500)
      }
    },
    updateTotalAmount(event) {
      if(event != null){
        this.countToBuy = event.target.value;
      }
      this.totalAmount = this.countToBuy * this.priceForSelectedVariation;
    }
  },
}
</script>
<style>
.multiselect-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.multiselect-label {
  white-space: nowrap;
}
</style>